import "./Form.css";
import {
  Button,
  TextField,
  OutlinedInput,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import UseTerms from "../UseTerms";
import olhaIssoLogo from "../../assets/olha_isso_logo.jpeg";

function Form() {
  const queryString = window.location.search; //URL
  const urlParams = new URLSearchParams(queryString); //Procuro params
  const eventId = urlParams.get("p");
  let navigate = useNavigate();

  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedColor, setIsCheckedColor] = useState(true);
  const [name, setName] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [time, setTime] = useState("15");

  const [isButtonBlocked, setIsButtonBlocked] = useState(false);
  const [avaiableName, setAvaiableName] = useState(true);
  const [telephoneExists, setTelephoneExists] = useState(true);
  const [isUseTermsVisible, setIsUseTermsVisible] = useState(false);

  const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(00) 00000-0000"
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });
  TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };
  const onSave = async (event) => {
    const trimmedName = name.trimEnd();
    event.preventDefault();
    if (trimmedName.length < 5) {
      setAvaiableName(false);
    }
    if (whatsapp.length !== 15) {
      setTelephoneExists(false);
    }
    if (!isChecked) {
      setIsCheckedColor(false);
    }
    if (isChecked && whatsapp.length === 15 && trimmedName.length >= 5) {
      setIsButtonBlocked(true);
      let response = await fetch(
        `https://olhaissomeu.com.br/api/register?name=${trimmedName}&phone=${whatsapp}&place=${eventId}&interval=${time}`,
        {
          method: "GET",
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (response.status === 200) {
        //Muda tela para ok
        const data = await response.json();
        console.log(data);
        navigate("/registerSuccess");
      } else {
        //Erro
        setTelephoneExists(false);
      }
      setIsButtonBlocked(false);
    }
  };

  const showUseTerms = () => {
    if (isUseTermsVisible) {
      setIsUseTermsVisible(false);
    } else {
      setIsUseTermsVisible(true);
    }
  };

  return (
    <>
      <form onSubmit={onSave} className="register-form">
        <img src={olhaIssoLogo} alt="Olha isso logo" />

        <TextField
          className="input-fields"
          value={name}
          label="Nome completo"
          onChange={(event) => setName(event.target.value)}
          error={!avaiableName}
          helperText={
            !avaiableName ? "Seu nome deve ter 5 ou mais carcteres" : " "
          }
          inputProps={{
            maxLength: 30,
          }}
        />

        <TextField
          className="input-fields"
          error={!telephoneExists}
          helperText={!telephoneExists ? "Telefone incorreto" : " "}
          label="WhatsApp"
          name="phone"
          onChange={(event) => setWhatsapp(event.target.value)}
          inputComponent={TextMaskCustom}
          value={whatsapp}
        />

        <h2>Tempo de uso</h2>
        <Select
          style={{ margin: "8px" }}
          value={time}
          onChange={(event) => setTime(event.target.value)}
        >
          <MenuItem value={15}>15 minutos</MenuItem>
          <MenuItem value={30}>30 minutos</MenuItem>
          <MenuItem value={60}>1 hora</MenuItem>
          <MenuItem value={120}>2 horas</MenuItem>
          <MenuItem value={240}>4 horas</MenuItem>
        </Select>

        <div className="checkbox-area">
          <FormControlLabel
            required
            control={
              <Checkbox
                checked={isChecked}
                onChange={(event) => setIsChecked(event.target.checked)}
              />
            }
          />
          <h5
            onClick={showUseTerms}
            style={!isCheckedColor ? { color: "red" } : {}}
          >
            Concordo com os termos de uso
          </h5>
        </div>
        <Button
          sx={{ backgroundColor: "#FF3535" }}
          style={{ margin: "8px" }}
          type="submit"
          disabled={isButtonBlocked}
          variant="contained"
        >
          Iniciar sessão
        </Button>
      </form>
      <OutlinedInput
        style={{ visibility: "hidden" }}
        value={whatsapp}
        onChange={(event) => setWhatsapp(event.target.value)}
        name="phone"
        readOnly={true}
        inputComponent={TextMaskCustom}
      />
      {isUseTermsVisible && <UseTerms closeUseTerms={showUseTerms} />}
    </>
  );
}

export default Form;
